// IT
export const hotelCalendarHc = {
  toolbar: {
    bulkEdit: "Modifica in blocco",
    cfgTitle: "Impostazioni del calendario",
    syncSection: "Sincronizzazione",
    resyncOta: `Risincronizza con l'OTA`,
    resyncOtaSub: "Reinvia disponibilità e tariffe al canale.",
  },
  mode: {
    calendar: "Calendario",
    rates: "Tariffe",
  },
  search: {
    placeholder: "Cerca ospite o codice…",
    clear: "Cancella",
    go: "Cerca",
    resultsHint: "{count} risultati — selezionane uno:",
    combo: "Combinata · {count} cam.",
  },
  header: {
    occupancy: "Occupazione {pct}%",
  },
  type: {
    roomsAbbr: "cam.",
    configTitle: "Impostazioni del tipo (OTA e regole di arrivo/partenza)",
    otaConnected: "OTA connessa",
    subscribeToConnect: "Abbonati per connettere le OTA",
  },
  rtCell: {
    editTooltip: "Clicca per modificare disponibilità, prezzo, minimo e chiusura",
    overbookRisk: "Rischio di overbooking",
    closedTag: "Chiuso",
  },
  rules: {
    sameDayCutoff: "Chiusura vendite in giornata alle {time}",
  },
  organizeRow: {
    title: "Da organizzare",
    unplacedCount: "{count} prenotazione non assegnata | {count} prenotazioni non assegnate",
    autoTooltip: "Riorganizza automaticamente le prenotazioni tra le camere in modo che entrino tutte",
    organizing: "Organizzazione…",
    organize: "Organizza",
  },
  footer: {
    available: "Disponibile",
    unavailable: "Non disponibile",
    closed: "Chiuso",
    overbookRisk: "Rischio di overbooking",
    realtime: "I valori si aggiornano in tempo reale",
    timezone: "Fuso orario: {tz}",
  },
  dayEdit: {
    oneDay: "un giorno",
    open: "Aperto",
    closed: "Chiuso",
    priceLabel: "Prezzo · tariffa standard",
    minStayLabel: "Soggiorno minimo (notti)",
    forSaleLabel: "Camere in vendita",
    forSaleHint: "limite · max {max}",
    applyMultiple: "Applicare a più date?",
    cancel: "Annulla",
    saving: "Salvataggio…",
    save: "Salva",
  },
  roomMenu: {
    create: "Crea prenotazione",
    createSub: `Prenotazione nell'intervallo selezionato`,
    block: "Blocca 1 camera",
    blockSub: `Chiude questa camera nell'intervallo`,
    unblock: "Rimuovi blocco",
    unblockSub: `Riapre questa camera nell'intervallo`,
    oos: "Fuori servizio",
    oosSub: "Manutenzione di questa camera",
  },
  closureMenu: {
    turnoverTitle: "Impostato dal tempo di preparazione",
    turnoverSub: "Si sposta con le date della prenotazione e scompare se viene annullata.",
    changeRule: "Modifica la regola",
    changeRuleSub: "Regola o disattiva il tempo di preparazione",
    editReason: "Modifica motivo",
    editReasonSub: "Cambia il motivo del blocco",
    changeRoom: "Cambia camera",
    changeRoomSub: `Sposta in un'altra camera del tipo`,
    unblock: "Rimuovi blocco",
    unblockSub: "Riapre e libera lo spazio",
    moveTo: "Sposta in…",
    noOtherRooms: "Non ci sono altre camere in questo tipo.",
    barTooltip: "Blocco: {reason} — clicca per modificare o rimuovere",
  },
  typeConfig: {
    seasons: "Price seasons",
    seasonsSub: "Raise or lower prices by date",
    manageOta: "Gestisci connessione OTA",
    connectOta: "Connetti OTA",
    otaSub: "Sincronizza la struttura con le OTA",
    arrivalRules: "Regole di arrivo e partenza",
    arrivalRulesSub: "Giorni di check-in / check-out consentiti",
  },
  // La habitación se ocupó unas HORAS, no una noche: en el calendario por
  // días se lee como un bloqueo con su motivo.
  hourly: {
    sold: "Venduta a ore",
    soldOne: "Venduta a ore · {range}",
    soldMany: "Venduta a ore · {count} soggiorni",
  },
  tooltip: {
    past: "Passata",
    unassignedHtml: "<strong>Nessuna camera assegnata.</strong> La disponibilità è distribuita tra le camere. Usa <strong>Organizza</strong> per riorganizzarla automaticamente, oppure clicca e assegnale una camera.",
    nights: "{count} notte | {count} notti",
    guests: "{count} ospite | {count} ospiti",
  },
  channels: {
    direct: "Diretta",
  },
  syncModal: {
    title: `Sincronizza con l'OTA`,
    message: `La disponibilità e il soggiorno massimo di questo calendario verranno ricalcolati e reinviati all'OTA.`,
    confirm: "Sì, sincronizza",
    cancel: "Annulla",
  },
  syncTooltip: {
    can: `Ricalcola e reinvia all'OTA la disponibilità e il soggiorno massimo (evita l'overbooking).`,
    cannot: "Connetti la struttura a un canale per poter sincronizzare.",
  },
  block: {
    editTitle: "Modifica motivo",
    createTitle: "Blocca camera",
    reasonLabel: "Motivo del blocco",
    reasonHint: "(verrà mostrato nel calendario)",
    placeholder: "Es: Manutenzione, uso del proprietario…",
    cancel: "Annulla",
    saving: "Salvataggio…",
    saveReason: "Salva motivo",
    blockBtn: "Blocca",
    defaultReason: "Bloccato",
    thisRoom: "questa camera",
    editReasonMsg: `Modifica il motivo del blocco di "{room}" ({count} notte). | Modifica il motivo del blocco di "{room}" ({count} notti).`,
    createMsg: `"{room}" ({unit}) verrà chiusa per {count} notte. Non sarà possibile prenotarla in quelle date; le altre camere del tipo restano disponibili. | "{room}" ({unit}) verrà chiusa per {count} notti. Non sarà possibile prenotarla in quelle date; le altre camere del tipo restano disponibili.`,
    presets: {
      maintenance: "Manutenzione",
      ownerUse: "Uso del proprietario",
      renovation: "Ristrutturazione",
      deepCleaning: "Pulizia profonda",
      externalReserved: "Riservato (esterno)",
    },
  },
  organizeModal: {
    title: "Organizza automaticamente",
    bodyHtml: `Cercheremo la migliore sistemazione e <strong>riorganizzeremo le prenotazioni tra le camere</strong> di questo tipo affinché <strong>{count} prenotazione non assegnata entri</strong> in modo continuo. | Cercheremo la migliore sistemazione e <strong>riorganizzeremo le prenotazioni tra le camere</strong> di questo tipo affinché <strong>{count} prenotazioni non assegnate entrino</strong> in modo continuo.`,
    point1Html: "Cambia solo la <strong>camera fisica</strong> assegnata.",
    point2Html: "Non vengono modificati <strong>date, prezzi né ospiti</strong>.",
    point3: "Se qualcuna non entra in modo continuo, ti avviseremo.",
    cancel: "Annulla",
    organizing: "Organizzazione…",
    confirm: "Sì, organizza",
  },
  empty: {
    noHotelTitle: "Nessun annuncio di tipo hotel",
    noHotelSubHtml: "Crea un annuncio di tipo <strong>Hotel</strong> o <strong>Camping</strong> per iniziare a gestire la disponibilità per camere.",
    noHotelBtn: "Vai agli annunci",
    noRoomsTitle: "{name} non ha camere",
    noRoomsSub: `Questo annuncio non ha ancora camere registrate. Aggiungi camere dalle impostazioni dell'annuncio per vedere il calendario.`,
    noRoomsBtn: "Configura annuncio",
  },
  mock: {
    today: "Oggi",
    month: "MAGGIO 2026",
    searchPlaceholder: "Cerca per nome o codice…",
    searchBtn: "Cerca",
    createBtn: "Crea prenotazione",
    na: "N/D",
    forSaleLabel: "Disp. in vendita",
    suiteDeluxe: "Suite Deluxe",
    standardRoom: "Camera Standard",
    roomsCount2: "(2 cam.)",
    roomsCount3: "(3 cam.)",
    no: "N.",
    room101: "Camera 101",
    room102: "Camera 102",
    room201: "Camera 201",
    room202: "Camera 202",
    room203: "Camera 203",
    d1: "lun 1",
    d2: "mar 2",
    d3: "mer 3",
    d4: "gio 4",
    d5: "ven 5",
    d6: "sab 6",
    d7: "dom 7",
    d8: "lun 8",
    d9: "mar 9",
    d10: "mer 10",
    d11: "gio 11",
    d12: "ven 12",
  },
  ops: {
    closingDay: "Chiusura giorno…",
    openingDay: "Apertura giorno…",
    saving: "Salvataggio…",
    movingBlock: "Spostamento blocco…",
    swappingBlockReservation: "Scambio di blocco e prenotazione…",
    swappingReservationBlock: "Scambio di prenotazione e blocco…",
    swappingRooms: "Scambio delle camere…",
    changingRoom: "Cambio camera…",
    organizingRooms: "Organizzazione delle camere…",
    syncingWithOta: `Sincronizzazione del calendario con l'OTA…`,
    processing: "Elaborazione…",
    settingMaintenance: "Messa in manutenzione…",
    clearingMaintenance: "Rimozione manutenzione…",
    updatingAvailability: "Aggiornamento disponibilità…",
    updatingReason: "Aggiornamento motivo…",
    closingRoom: "Chiusura camera…",
    removingBlock: "Rimozione blocco…",
  },
  toasts: {
    dayClosed: "Giorno chiuso",
    dayOpened: "Giorno aperto",
    availabilityUpdateErr: "Impossibile aggiornare la disponibilità",
    dayUpdated: "Giorno aggiornato",
    daySaveErr: "Impossibile salvare il giorno",
    moveTargetMultipleReservations: `La destinazione ha più prenotazioni in quell'intervallo; spostale manualmente.`,
    roomRejectsBlock: `Quella camera non accetta il blocco in quell'intervallo`,
    blockMoved: "Blocco spostato di camera",
    blockMoveErr: "Impossibile spostare il blocco",
    swapStartErr: "Impossibile avviare lo scambio",
    reservationNoFitSwap: `La prenotazione non entra nell'altra camera per tutto il suo intervallo; impossibile scambiare.`,
    reservationMoveErr: "Impossibile spostare la prenotazione",
    swapCompleteErr: "Impossibile completare lo scambio (è stato annullato)",
    blockReservationSwapped: "Blocco e prenotazione scambiati",
    swapErr: "Impossibile scambiare",
    rangeHasOccupiedOrClosed: `L'intervallo include notti occupate o chiuse in questa camera.`,
    organizeErr: "Impossibile organizzare automaticamente.",
    organizeNothing: `Non c'era nulla da riorganizzare.`,
    organizePartial: "{done} prenotazione/i sono state organizzate, ma {unplaced} non entra/entrano in modo continuo in nessuna combinazione.",
    organizeDoneAssigned: "Calendario organizzato: {assigned} assegnata/e",
    organizeDoneMoved: ", {moved} spostata/e di camera",
    swapGroupDone: "Scambio di gruppo completato: {groupCount} ⇄ {swappedCount} prenotazioni.",
    roomsSwappedWith: "Camere scambiate con {names}.",
    noPropertyToSync: "Nessuna struttura da sincronizzare.",
    calendarResynced: `Calendario ricalcolato e sincronizzato con l'OTA.`,
    syncErr: `Impossibile sincronizzare il calendario con l'OTA.`,
    genericError: "Errore",
    reservationNoFitSwapStrict: "Impossibile scambiare: la prenotazione non è libera per tutto il suo intervallo.",
    reservationBlockSwapped: "Prenotazione e blocco scambiati",
    roomCloseErr: "Impossibile chiudere la camera",
    reasonUpdated: "Motivo aggiornato",
    roomClosedInRange: `Camera chiusa nell'intervallo`,
    blockRemoved: "Blocco rimosso",
    blockRemoveErr: "Impossibile rimuovere il blocco",
    searchMinChars: "Digita almeno 2 caratteri per cercare",
    searchNoResults: "Nessuna prenotazione trovata per questa ricerca",
    searchErr: "Errore nella ricerca delle prenotazioni",
  },
  summary: {
    stateAvailable: "Disponibile",
    stateClosed: "Chiuso",
    stateNoDisp: "Non disp.",
  },
};
